<template>
  <div class="collection-view view">
    <div class="collection-content-view content-view">
      <div class="cc-header content-header">
        <div class="content-header-sparkle"></div>
        CONGRATULATIONS, YOU'VE COLLECTED {{totalCorrectMisfits}} {{totalCorrectMisfits > 1 ? 'MISFITS' : 'MISFIT'}}!
      </div>
      <div class="cc-items-container">
        <div class="cc-items-row">
          <div class="cc-item cc-item-label">MER-BEARS</div>
          <div class="cc-item cc-item-label">TROPICAL<br />UNI-SHARKS</div>
        </div>
        <div
          class="cc-items-row"
          v-for="(misfit, index) in misfitMerbears"
        >
          <div class="cc-item">
            <img :src="checkIfUserHasCollected(misfitMerbears[index].id) ? misfitMerbears[index].assetURL : misfitMerbears[index].quizOutlineAssetURL" />
            <div class="cc-item-flavor-label">{{getMisfitDisplayLabel(misfitMerbears[index])}}</div>
          </div>
          <div class="cc-item">
            <img :src="checkIfUserHasCollected(misfitUnisharks[index].id) ? misfitUnisharks[index].assetURL : misfitUnisharks[index].quizOutlineAssetURL" />
            <div class="cc-item-flavor-label">{{getMisfitDisplayLabel(misfitUnisharks[index])}}</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, onBeforeMount, onMounted } from '@vue/composition-api';

export default {
  name: 'Collection',
  components: {

  },

  setup(props, context) {
    const {
      $router,
      $store
    } = context.root;

    /**
     * Properties
     */
    const totalCorrectMisfits = computed(() => {
      return $store.getters['user/getTotalCorrectMisfits'];
    })

    const misfitMerbears = computed(() => {
      return $store.getters['product/getMisfitMerbears'];
    });

    const misfitUnisharks = computed(() => {
      return $store.getters['product/getMisfitUnisharks'];
    });

    /**
     * Vue Hooks
     */
    onMounted(() => {

    });

    /**
     * Methods
     */
    const checkIfUserHasCollected = (misfitId) => {
      return $store.getters['user/checkIfMisfitCollected'](misfitId);
    }

    const getMisfitFlavor = (id) => {
      const misfitFlavor = $store.getters['product/getMisfitFlavorById'](id);

      console.log(misfitFlavor);

      // if( misfitFlavor != null ) {
      //   console.log('id:', misfitFlavor.id);
      //   console.log('label:', misfitFlavor.label);
      //   console.log('assetURL:', misfitFlavor.assetURL);
      // }

      return misfitFlavor;
    }

    const getMisfitDisplayLabel = (misfit) => {
      let flavorOne = $store.getters['product/getMisfitFlavorById'](misfit.flavors[0]);
      let flavorTwo = $store.getters['product/getMisfitFlavorById'](misfit.flavors[1]);

      return flavorOne.label + ' + ' + flavorTwo.label;
      // return $store.getters['product/getMisfitDisplayLabel'](id);
    }

    return {
      // Properties
      totalCorrectMisfits,
      misfitMerbears,
      misfitUnisharks,

      // Methods
      checkIfUserHasCollected,
      getMisfitFlavor,
      getMisfitDisplayLabel,
    }
  },
}

</script>

<style lang="scss" scoped>
$padding-top: 180px;
$mobile-padding-top: 19vh;
$mobile-height-short-padding-top: 15vh;

.collection-view {
  padding-top: $padding-top;
}

.collection-content-view {
  // position: relative;
  font-size: 2rem;
  // min-height: calc(var(--vh, 1vh) * 100 - #{$padding-top});
  // min-height: calc(100%)
  height: calc(#{$min-height} - #{$padding-top});
}

.cc-header {
  position: relative;
  @include font-knewave;
  font-size: 1.1em;
  width: 86%;
  margin: 0 auto 0 auto;
  padding-top: 1em;
  text-align: center;
  letter-spacing: 0.03em;
}

.cc-items-container {
  position: relative;
  width: 90%;
  margin: 1.3em auto 0 auto;
}

.cc-items-row {
  position: relative;
  display: flex;
  font-size: 0.8em;
  margin-bottom: 0.8em;

  &:first-child {
    margin-bottom: 0;
  }
}

.cc-item {
  position: relative;
  width: 46%;
  margin: 0 2%;

  img {
    position: relative;
    display: block;
    width: 80%;
    margin: 0 auto;
  }
}

.cc-item-label {
  @include font-knewave;
  font-size: 1em;
  text-align: center;
  color: $font-dark-blue-color;
}

.cc-item-flavor-label {
  @include font-montserrat;
  font-size: 0.7em;
}

@include height-medium {
  .collection-content-view {
    font-size: 1.8rem;
  }
}

@include height-short {
  .collection-content-view {
    font-size: 1.6rem;
  }
}

@include mobile {
  .collection-view {
    padding-top: $mobile-padding-top;
  }

  .collection-content-view {
    height: initial;
    min-height: calc(var(--vh, 1vh) * 100 - #{$mobile-padding-top});
    font-size: 1.6rem;
    padding-top: 0.75em;
  }

  .cc-header {
    font-size: 1.0em;
    width: 66%;
    padding-top: 0.5em;
  }

  .cc-items-container {
    width: 80%;
  }
}

// @include mobile-medium {
//
// }

@include mobile-small {
  .collection-content-view {
    font-size: 1.6rem;
  }

  .cc-items-container {
    width: 80%;
  }
}

body.touch {
  @include height-medium {

  }

  @include height-short {
    .collection-view {
      padding-top: #{$mobile-height-short-padding-top};
    }

    .collection-content-view {
      min-height: calc(var(--vh, 1vh) * 100 - #{$mobile-height-short-padding-top});
    }

    .cc-items-container {
      width: 72%;
    }
  }

  @include mobile-aspect-ratio-40-62 {
    .cc-header {
      font-size: 0.9em;
      width: 58%;
    }

    .cc-items-container {
      width: 68%;
    }
  }

  @include mobile-aspect-ratio-40-59 {
    .collection-content-view {

    }

    .cc-header {
      font-size: 0.9em;
      width: 54%;
    }

    .cc-items-container {
      width: 62%;
    }
  }
}

</style>
